import React from 'react';

export default function LoadingSpinner() {
  return (
    <div className="siteplan__loading">
      <div className="siteplan__spinner">
        <div className="siteplan__spinner-dot siteplan__spinner-dot--one" />
        <div className="siteplan__spinner-dot siteplan__spinner-dot--two" />
        <div className="siteplan__spinner-dot siteplan__spinner-dot--three" />
        <div className="siteplan__spinner-dot siteplan__spinner-dot--four" />
        <div className="siteplan__spinner-dot siteplan__spinner-dot--five" />
        <div className="siteplan__spinner-dot siteplan__spinner-dot--six" />
        <div className="siteplan__spinner-dot siteplan__spinner-dot--seven" />
        <div className="siteplan__spinner-dot siteplan__spinner-dot--eight" />
        <div className="siteplan__spinner-dot siteplan__spinner-dot--nine" />
        <div className="siteplan__spinner-dot siteplan__spinner-dot--ten" />
        <div className="siteplan__spinner-dot siteplan__spinner-dot--eleven" />
        <div className="siteplan__spinner-dot siteplan__spinner-dot--twelve" />
      </div>
    </div>
  );
}
